<template>
    <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
       <template #item-content.1>
          <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'MAKLUMAT TERNAKAN'" >
             <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
             <template #title>
                   MAKLUMAT TERNAKAN
                </template>
             <div class="w-table-wrap" style="max-height: 400px;">
                <div class="table-profil-scrol">
                   <table class="w-table" color="light" >
                      <thead>
                         <tr>
                            <th class="w-table__header  text-center" width="1%">BIL</th>
                            <th class="w-table__header  text-center">NO KES </th>
                            <th class="w-table__header  text-center">NO PENDAFTARAN</th>
                            <th class="w-table__header  text-center">ID | NAMA TERNAKAN</th>
                            <th class="w-table__header  text-center">JENIS TERNAKAN</th>
                            <th class="w-table__header  text-center">BAKA</th>
                            <th class="w-table__header  text-center">JENIS PERKHIDMATAN </th>
                            <th class="w-table__header  text-center">NAMA PEMERIKSA </th>
                            <th class="w-table__header  text-center">KEPUTUSAN </th>
                            <!-- <template v-if="data.lkp_status_id==39"> -->
                               <th class="w-table__header  text-center">TINDAKAN</th>
                            <!-- </template> -->
                         </tr>
                      </thead>
                      <tbody>
                         <template v-for="(dt, ind) in data.ternakan_list">
                            <tr class="w-table__row" >
                               <td class="w-table__cell text-center" >{{ind+1}}</td>
                               <td class="w-table__cell text-center" >{{dt.no_kes}}</td>
                               <td class="w-table__cell text-center" >{{dt.id_ternakan}}</td>
                               <td class="w-table__cell text-center" style="text-transform: uppercase;">{{dt.id_ternakan_list}} | {{dt.nama_ternakan}}</td>
                               <td class="w-table__cell text-center" >{{dt.lkp_ternakan}}</td>
                               <td class="w-table__cell text-center" >{{dt.baka}}</td>
                               <td class="w-table__cell text-center" >{{dt.lkp_art}}</td>
                               <td class="w-table__cell text-center" >{{dt.user}}</td>
                               <!-- <td class="w-table__cell text-center" :style="dt.hantar == 1 ? { backgroundColor: '#4CAF50', color: 'white' } : {}">{{ dt.keputusan }}</td> -->
                               <td class="w-table__cell text-center" 
                                  :style="dt.hantar == 1 ? 
                                      (dt.keputusan.toLowerCase() === 'lulus' ? { backgroundColor: '#4CAF50', color: 'white' } : 
                                       dt.keputusan.toLowerCase() === 'gagal' ? { backgroundColor: '#F44336', color: 'white' } :
                                       dt.keputusan.toLowerCase() === 'lulus bersyarat' ? { backgroundColor: '#FFEB3B' } : {}) : {}">
                                  {{ dt.keputusan }}
                              </td>
                               <td class="w-table__cell text-center" width="15%" >
                                    <w-tooltip top color="white" bg-color="black" v-if=" dt.hantar == 1" >
                                      <template #activator="{ on }">
                                         <w-button  bg-color="primary" v-on="on" :route="$route('art.semakan.penilaian.bse_show',dt.id)" class="be fs-2"><div style="width: 8px"></div>
                                         <w-icon md class="mr2">fal fa-eye</w-icon>
                                         </w-button>
                                       </template>
                                       Papar
                                     </w-tooltip>
                                    <w-tooltip top color="white" bg-color="black" v-else-if=" $zutil.anyRole(['4'])" >
                                      <template #activator="{ on }">
                                          <template v-if = "data.lkp_status_id != 31 && data.lkp_status_id != 21 ">
                                              <w-button  bg-color="warning" v-on="on"  :route="$route('art.semakan.penilaian.form',dt.id)" class="be fs-2"><div style="width: 8px"></div>
                                            <w-icon md class="mr2">fal fa-pencil</w-icon>
                                            </w-button>
                                          </template>
                                       </template>
                                       Kemaskini
                                     </w-tooltip>
                                     &nbsp;
                                   <w-tooltip md top align-right color="white" bg-color="black">
                                      <template #activator="{ on }">
                                         <!-- <inertia-link :href="$route('pdbf.penilaian.sejarah', dt.ternakan_id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                                           <w-icon md class="mr2">fal fa-history</w-icon>
                                         </inertia-link> -->
                                         <inertia-link :href="$route('art.semakan.penilaian.sejarah', dt.ternakan_id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                                           <w-icon md class="mr2">fal fa-history</w-icon>
                                         </inertia-link>
                                       </template>
                                       Sejarah
                                     </w-tooltip>
                               </td>
                            </tr>
                         </template>
                      </tbody>
                   </table>
                </div>
             </div>
          </w-form>
       </w-card>
    </template>
    <template #item-content.2 >
         <CajBseShow :d_data="data" :d_segmenName="segmenName" v-if="data.id > 0"/>
      </template>
 </w-tabs>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import VueQrcode from 'vue-qrcode'
import CajBseShow from './Sub/CajBseShow.vue'


export default {
extends: ZResource,
components: {
VueQrcode, CajBseShow
},
props: {
d_id: [Array, Object, String],

},
data() {
return {
 resourceurl: 'art.permohonan',
 crumbs: [
   { label: this.$page.props.app_name, route: '/home' },
   { label: 'Pembiakan Permohonan', route: '/art' },
   { label: 'Permohonan', route: '/art/permohonan' },
   { label: 'Papar', route: '/art/permohonan/'+this.id },
 ],

 title : '',
 id: this.d_id,
 data : {id : 0},
 activeTab : 0,
 // activeTabModal : 0,
 // ada_bunting: 0,
 ternakan_list:[],
 tabs: [
       { title: 'RUMUSAN PERKHIDMATAN', content: '' },
       { title: 'CAJ PERKHIDMATAN', content: '' },
 ],
 ibvk: [],
 negri: [],
 persendirian: [],
 juruteknik_list: [],
 lkp_tujuan:[],
 jankaan_biang_semula:null,
}
},
methods: {
 validateForm() {
    this.loading=true;
    let isValid = true;
    let jumlah_lulus = 0;
    this.data.ternakan_list.forEach((row) => {
       if (row.pilih == true) {
          jumlah_lulus = 1;
       }
    })

    if (jumlah_lulus == 0) {
      this.$zutil.notify("Pastikan data sudah di Pilih", false);
      this.loading=false;
      return false;
    }
 },

 
tutup(){
    this.$inertia.visit(window.route('art.semakan.index'));
  },

cetak(data){
   // this.$inertia.visit(route("kursus.kursus.peserta.sijil_peserta", dt.peseta_user_id) +"?kursus_id="+dt.id,);
   window.open( window.route('art.permohonan.cetak', data), '_blank');
},


 
getData()
{
  this.$zcomm.get(this.api_service + 'art/show/'+this.id, {}).then(res => {

    this.data = res

    this.params = location.search
      .slice(1)
      .split('&')
      .map(p => p.split('='))
      .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {})

    if(this.params.tab == 2){ 

      this.activeTab = 1

    } else {

      this.activeTab = 0

    }

  })
},




},
watch: {

},
mounted() {
this.getData();



},
}
</script>

<style>
.table-aims td{
padding: 7px;
}
</style>

